(function () {
  function parseSaleStart(raw) {
    if (!raw) return null;

    let d = new Date(raw);
    if (!isNaN(d.getTime())) return d;

    const m = String(raw).trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      return new Date(+m[1], +m[2] - 1, +m[3], 0, 0, 0);
    }
    return null;
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatRemaining(ms) {
    const total = Math.max(0, Math.floor(ms / 1000));
    const d = Math.floor(total / 86400);
    const h = Math.floor((total % 86400) / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;

    if (d > 0) return `${d}d ${pad(h)}h ${pad(m)}m ${pad(s)}s`;
    return `${pad(h)}h ${pad(m)}m ${pad(s)}s`;
  }

  function init(el) {
    // ✅ prevent double init (important when re-running initAll)
    if (el.dataset.skadiTimerInit === '1') return;
    el.dataset.skadiTimerInit = '1';

    const raw = el.dataset.saleStart;
    const days = parseInt(el.dataset.saleDays || '4', 10);

    const start = parseSaleStart(raw);
    if (!start) return;

    const end = new Date(start.getTime() + days * 86400000);
    const out = el.querySelector('.skadi-deal-pill__timer');
    if (!out) return;

    function tick() {
      const now = new Date();
      const remaining = end - now;

      if (remaining <= 0) {
        el.style.display = 'none';
        clearInterval(timer);
        return;
      }

      out.innerHTML =
        '<span class="skadi-timer-muted">Ends in:</span>' +
        formatRemaining(remaining);
    }

    tick();
    const timer = setInterval(tick, 1000);
  }

  function initAll() {
    document
      .querySelectorAll('.skadi-deal-pill[data-sale-start]')
      .forEach(init);
  }

  // ✅ initial load
  document.addEventListener('DOMContentLoaded', initAll);

  // ✅ theme editor / Shopify section re-renders
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
  document.addEventListener('shopify:section:select', initAll);

  // ✅ catch dynamically injected cards (filters, infinite scroll, quick view)
  const mo = new MutationObserver(function () {
    initAll();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
